// This file is autogenerated. Please don't modify it directly. See the README for details
/* tslint:disable */
import MiniCalendarIcons from './MiniCalendarIcons';

export type MiniCalendarIconsSubset = { [icon in MiniCalendarIcons]: string };

export let MiniCalendarIconsDefinitions: MiniCalendarIconsSubset = {
    AlarmClock: '\ue919',
    CalendarAgenda: '\uee9a',
    CalendarDay: '\ue8bf',
    ChevronDownMed: '\ue972',
    ChevronUpMed: '\ue971',
    Error: '\ue783',
    Globe: '\ue774',
    List: '\uea37',
    Lock: '\ue72e',
    ResponsesMenu: '\uf768',
    ShowTimeAs: '\uf787',
    SkypeForBusinessLogo: '\uf0fc',
    SkypeForBusinessLogo16: '\uf40f',
    SkypeLogo: '\ueb6f',
    SkypeLogo16: '\uf40e',
    StatusCircleQuestionMark: '\uf142',
    SyncOccurence: '\uf4a3',
    Tag: '\ue8ec',
    TagSolid: '\uf70e',
    TeamsLogo: '\uf27b',
    TimePicker: '\ue367',
    Unlock: '\ue785',
    UnsyncOccurence: '\uf4a4',
    Up: '\ue74a',
    UserFollowed: '\uf25c',
    UserRemove: '\uf69b',
};

export default {
    fontFileName: 'miniCalendarIcons',
    icons: MiniCalendarIconsDefinitions,
};
